export default __webpack_public_path__ + "static/media/SC.da090fbe.svg";